export default __webpack_public_path__ + "static/logo-9226a9640b041a65355f4d78f1a12714.svg";